module.exports = __webpack_public_path__ + "img/4b.e2d2bd26.jpg";